import { ToastsStore } from 'react-toasts'

// eslint-disable-next-line import/prefer-default-export
export const toaster = ToastsStore
